// extracted by mini-css-extract-plugin
export default {"projectFadeIn":"Project_projectFadeIn__E8M7E","fadeIn":"Project_fadeIn__dvrHO"};